function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/* ========================================================================
 * Apricot's Modals
 * ========================================================================
 *
 * It has the ability to display multiple modals at the same time
 * ======================================================================== */

// SCSS
import "../scss/includes/apricot-base.scss";
import "../scss/includes/modal.scss";
import "../scss/includes/button.scss";

// javaScript
import Utils from "./CBUtils";
/**
 * Modal
 *
 * @class
 * @param {Object} data
 * @param {Element|String} data.elem
 * @param {Element|String} data.trigger
 * @param {Element|String} data.focusElem
 * @param {Boolean} data.nested
 * @param {Boolean} data.shadowRoot
 * @param {Boolean} data.videoModal
 * @param {String} data.closeAttr
 * @param {Boolean} data.disableFocus
 * @param {Boolean} data.disableScroll
 * @param {Boolean} data.disableHeightAdjustment
 * @param {Boolean} data.disableHeightAdjustmentAria
 * @param {Boolean} data.escClose
 * @param {Boolean} data.awaitOpenAnimation
 * @param {Boolean} data.awaitCloseAnimation
 * @param {Boolean} data.openAnimation
 * @param {Boolean} data.closeAnimation
 * @param {Boolean} data.controlled
 * @param {Boolean} data.analytics
 * @param {String} data.analyticsTitle
 * @param {Boolean} data.analyticsOnClose
 * @param {Function} data.onShow
 * @param {Function} data.onClose
 * @returns {{show: Function}}
 * @returns {{close: Function}}
 * @returns {{adjustHeight: Function}}
 * @returns {{destroy: Function}}
 */

var Modal = function Modal() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var defaultData = {
    elem: null,
    trigger: null,
    focusElem: null,
    shadowRoot: false,
    nested: false,
    videoModal: false,
    closeAttr: "data-cb-modal-close",
    disableFocus: false,
    disableScroll: false,
    disableHeightAdjustment: false,
    disableHeightAdjustmentAria: false,
    escClose: true,
    awaitOpenAnimation: true,
    awaitCloseAnimation: true,
    openAnimation: true,
    closeAnimation: true,
    controlled: false,
    analytics: false,
    analyticsTitle: null,
    analyticsOnClose: false,
    onShow: function onShow() {},
    onClose: function onClose() {}
  };
  data = _objectSpread(_objectSpread({}, defaultData), data);
  var elem = typeof data.elem === "string" ? document.getElementById(data.elem) : data.elem;
  if (!Utils.elemExists(elem)) return null;
  var trigger = null;
  var focusElem = null;
  var activeElement = null;
  var modalContainer = null;
  var modalHeader = null;
  var modalContent = null;
  var modalFooter = null;
  var elemId = "";
  var adjustableContent = null;
  var videoIframe = null;
  var videoSrc = "";
  var analyticsTitle = "";
  var init = function init() {
    elem.modal = "cb";
    modalComponents();
    // Add Events
    addEventListeners();
    if (Utils.elemExists(trigger)) {
      trigger.addEventListener("click", showModal);
    }
  };
  var modalComponents = function modalComponents() {
    trigger = typeof data.trigger === "string" ? document.getElementById(data.trigger) : data.trigger;
    focusElem = typeof data.focusElem === "string" ? document.getElementById(data.focusElem) : data.focusElem;
    modalContainer = elem.querySelector(".cb-modal-container");
    modalHeader = elem.querySelector(".cb-modal-header");
    modalContent = elem.querySelector(".cb-modal-content");
    modalFooter = elem.querySelector(".cb-modal-footer");

    // make sure Modal has ID
    elemId = Utils.attr(elem, "id") ? Utils.attr(elem, "id") : Utils.uniqueID(5, "apricot_");
    Utils.attr(elem, "id", elemId);
    if (modalContent) {
      if (modalContent.querySelector(".cb-notification")) {
        adjustableContent = modalContent.querySelector(".cb-notification-content");
      } else {
        adjustableContent = modalContent;
      }
    } else {
      console.warn("Apricot Modal: Seems like your modal has no content block.");
    }

    // needed for style adjustment
    if (modalHeader && modalHeader.querySelector(".cb-btn-close")) {
      Utils.addClass(modalHeader, "cb-modal-has-close");
    }

    // video Modal
    if (data.videoModal) {
      videoIframe = elem.querySelector("iframe");
      if (videoIframe) {
        videoSrc = Utils.attr(videoIframe, "data-cb-src");
      }
    }

    // activate analytics tracker
    if (data.analytics) {
      var title = elem.querySelector(".cb-modal-title");
      var dialogTitle = elem.querySelector(".cb-notification-title");
      analyticsTitle = data.analyticsTitle ? data.analyticsTitle : Utils.elemExists(title) ? title.textContent || title.innerText : Utils.elemExists(dialogTitle) ? dialogTitle.textContent || dialogTitle.innerText : "missing title - ".concat(elemId);
      Utils.attr(modalContainer, "data-cbtrack-modal", analyticsTitle);
    }
  };
  var showModal = function showModal(e) {
    if (e) e.preventDefault();
    // make sure we have all events
    addEventListeners();

    // this should be the trigger
    activeElement = document.activeElement;
    elem.setAttribute("aria-hidden", "false");
    if (data.videoModal) {
      if (videoIframe) {
        videoIframe.src = videoSrc;
      }
    }
    Utils.addClass(elem, "cb-open");
    if (data.awaitOpenAnimation) {
      // dispatch modal start show
      var event = new CustomEvent("apricot_modalShow_start");
      activeElement && activeElement.dispatchEvent(event);
      elem.dispatchEvent(event);

      // animationend event is fired when a CSS Animation has completed
      elem.addEventListener("animationend", startAnimation, false);
    } else {
      calculateHeight();
      setFocusToFirstNode();
      scrollBehaviour("disable");
      data.onShow && data.onShow(elem);

      // dispatch modal show
      var _event = new CustomEvent("apricot_modalShow");
      activeElement && activeElement.dispatchEvent(_event);
      elem.dispatchEvent(_event);
    }

    // trigger analytics tracker
    if (data.analytics) {
      trackAnalytics(true);
    }
    var body = document.getElementsByTagName("body")[0];
    Utils.addClass(body, "cb-modal-open");
  };
  var closeModal = function closeModal(options) {
    if (!elem) return;

    // only close the actual modal
    if (!!data.nested && options.activeModalID) {
      if (options.activeModalID !== elemId) {
        return;
      }
    }
    elem.setAttribute("aria-hidden", "true");

    // make sure the src is removed when modal closes
    if (data.videoModal) {
      if (videoIframe) {
        videoIframe.src = "";
      }
    }
    scrollBehaviour("enable");

    // set focus to active elem, A11Y
    activeElement && activeElement.focus();
    if (options && options.onClose) {
      options.onClose(elem, options.source);
    } else if (data.onClose) {
      data.onClose(elem, options.source);
    }
    if (data.awaitCloseAnimation) {
      // dispatch modal start close
      var event = new CustomEvent("apricot_modalClose_start");
      activeElement && activeElement.dispatchEvent(event);
      elem.dispatchEvent(event);

      // animationend event is fired when a CSS Animation has completed
      elem.addEventListener("animationend", endAnimation, false);
    } else {
      Utils.removeClass(elem, "cb-open");

      // dispatch modal close
      var _event2 = new CustomEvent("apricot_modalClose");
      activeElement && activeElement.dispatchEvent(_event2);
      elem.dispatchEvent(_event2);
    }

    // trigger analytics tracker
    if (data.analytics && data.analyticsOnClose) {
      trackAnalytics(false);
    }
    var body = document.getElementsByTagName("body")[0];
    Utils.removeClass(body, "cb-modal-open");
    resetHeight();
  };
  var calculateHeight = function calculateHeight() {
    if (!Utils.hasClass(elem, "cb-open")) return;
    if (data.disableHeightAdjustment) return;

    // no content
    if (!adjustableContent) return;
    // empty content
    if (!adjustableContent.hasChildNodes()) return;
    if (!Utils.hasClass(elem, "cb-open")) return;
    resetHeight();

    // Only calculate when the modal is open
    if (data.videoModal) {
      var pageHeight = window.innerHeight;
      var pageWidth = window.innerWidth;
      var height = parseInt(pageHeight, 10) - 96;
      var width = parseInt(pageWidth, 10) - 96;
      var w = 0;
      var h = 0;
      if (pageWidth < pageHeight) {
        w = width * 98 / 100;
        h = Math.round(w * 9 / 16);
      } else {
        h = height * 98 / 100;
        w = Math.round(h * 16 / 9);
      }
      modalContainer.style.width = w + "px";
      modalContainer.style.height = h + "px";
    } else if (Utils.hasClass(elem, "cb-open")) {
      var ch = Utils.height(modalContainer);
      var mh = Utils.height(adjustableContent);
      var hh = 0;
      var fh = 0;
      var newHeight = 0;
      if (modalHeader) hh = Utils.outerHeight(modalHeader);
      if (modalFooter) {
        fh = Utils.outerHeight(modalFooter);
      } else {
        // GS-9130
        // fh = 24;
        fh = 0;
      }
      var mpAdjust = 24 * 3;
      var header = null;
      if (modalContent.querySelector(".cb-notification")) {
        header = modalContent.querySelector(".cb-notification-header");
      }
      if (modalContent.querySelector(".cb-notification")) {
        fh = 0;
        mpAdjust = 24 * 2 + 12;
        hh = Utils.outerHeight(header);
      }
      newHeight = ch - mpAdjust - hh - fh;
      if (mh > newHeight) {
        adjustableContent.style.overflowY = "auto";
        adjustableContent.style.height = newHeight + "px";
        if (!data.disableHeightAdjustmentAria) {
          Utils.attr(adjustableContent, "tabindex", "0");
          Utils.attr(adjustableContent, "role", "region");
          Utils.attr(adjustableContent, "aria-label", "scrollable content");
        }
      } else {
        resetHeight();
      }
    }
  };
  var resetHeight = function resetHeight() {
    if (data.videoModal) {
      if (!modalContainer) return;
      modalContainer.style.overflowY = "";
      modalContainer.style.height = "";
    } else {
      if (!adjustableContent) return;
      if (!adjustableContent.hasChildNodes()) return;
      adjustableContent.style.overflowY = "";
      adjustableContent.style.height = "";
      if (!data.disableHeightAdjustmentAria) {
        Utils.removeAttr(adjustableContent, "tabindex");
        Utils.removeAttr(adjustableContent, "role");
        Utils.removeAttr(adjustableContent, "aria-label");
      }
    }
  };
  var getFocusableNodes = function getFocusableNodes() {
    var nodes = elem.querySelectorAll(Utils.FOCUSABLE_ELEMENTS);
    return Array.apply(void 0, _toConsumableArray(nodes));
  };
  var setFocusToFirstNode = function setFocusToFirstNode() {
    if (data.disableFocus) return;
    var dialog = elem.querySelector('div[role="dialog"]');
    if (dialog) {
      // set focus to specific element when requested
      if (Utils.elemExists(focusElem)) {
        focusElem.focus();
      } else {
        Utils.attr(dialog, "tabIndex", "0");
        dialog.focus();
      }
    } else {
      var focusableNodes = getFocusableNodes();
      if (focusableNodes.length) focusableNodes[0].focus();
    }
  };
  var maintainFocus = function maintainFocus(event) {
    var focusableNodes = getFocusableNodes();
    var active = data.shadowRoot ? Utils.getActiveElementShadowRoot() : document.activeElement;

    // if disableFocus is true
    if (!elem.contains(active)) {
      focusableNodes[0].focus();
    } else {
      var focusedItemIndex = focusableNodes.indexOf(active);
      if (event.shiftKey && focusedItemIndex === 0) {
        focusableNodes[focusableNodes.length - 1].focus();
        event.preventDefault();
      }
      if (!event.shiftKey && focusedItemIndex === focusableNodes.length - 1) {
        focusableNodes[0].focus();
        event.preventDefault();
      }
    }
  };

  // true: onShow
  // false: onClose
  var trackAnalytics = function trackAnalytics(mode) {
    var eventName = mode ? "cbTrack-modalOpen" : "cbTrack-modalClose";
    document.dispatchEvent(new CustomEvent(eventName, {
      bubbles: true,
      detail: {
        modalName: analyticsTitle,
        modalEl: modalContainer
      }
    }));
  };
  var modalOnClick = function modalOnClick(event) {
    var node = event.target;
    var parent = Utils.parent(node);
    if (parent.tagName === "BUTTON") {
      node = parent;
    }
    if (node.hasAttribute(data.closeAttr)) {
      var src = "";
      if (Utils.hasClass(node, "cb-modal-overlay")) {
        src = "overlay";
      } else if (Utils.hasClass(node, "cb-btn-close") && Utils.hasClass(node, "cb-btn-greyscale")) {
        src = "close";
      } else if (Utils.hasClass(node, "cb-btn")) {
        var id = "_".concat(Utils.attr(node, "id")) || "";
        src = "button".concat(id);
      }
      var obj = {};
      if (src !== "") obj = _objectSpread({}, {
        source: src
      });
      if (data.nested) {
        var closestModal = node.closest(".cb-modal");
        if (closestModal) {
          obj = _objectSpread(_objectSpread({}, obj), {
            activeModalID: Utils.attr(closestModal, "id")
          });
        }
      }
      closeModal(obj);
      event.preventDefault();
    }
  };
  var modalOnKeyDown = function modalOnKeyDown(event) {
    var body = document.getElementsByTagName("body")[0];
    // If toast esc is not in place
    if (event.keyCode === 27 && data.escClose && Utils.hasClass(elem, "cb-open") && !Utils.attr(body, "data-cb-esc")) {
      closeModal({
        source: "keyboard"
      });
    }
    if (!Utils.hasClass(elem, "cb-photo-gallery-modal")) {
      if (event.keyCode === 9) maintainFocus(event);
    }
  };
  var windowOnResize = function windowOnResize() {
    calculateHeight();
  };
  var addEventListeners = function addEventListeners() {
    if (elem.modalEvent) return;
    elem.modalEvent = true;
    if (data.openAnimation === false) {
      Utils.addClass(elem, "cb-no-animation-open");
    }
    if (data.closeAnimation === false) {
      Utils.addClass(elem, "cb-no-animation-close");
    }
    elem.addEventListener("touchstart", modalOnClick, {
      passive: true
    });
    elem.addEventListener("click", modalOnClick);
    document.addEventListener("keydown", modalOnKeyDown);
    window.addEventListener("resize", windowOnResize);
  };
  var removeEventListeners = function removeEventListeners() {
    elem.modalEvent = null;
    elem.removeEventListener("touchstart", modalOnClick, {
      passive: true
    });
    elem.removeEventListener("click", modalOnClick);
    document.removeEventListener("keydown", modalOnKeyDown);
    window.removeEventListener("resize", windowOnResize);
  };
  var cleanUp = function cleanUp() {
    var body = document.getElementsByTagName("body")[0];
    if (body) {
      body.style.overflowY = "";
      body.style.height = "";
      Utils.removeClass(body, "cb-modal-open");
    }
    if (data.videoModal) {
      if (modalContainer) {
        modalContainer.style.overflowY = "";
        modalContainer.style.height = "";
        modalContainer.style.width = "";
        modalContainer.style.height = "";
      }
    } else {
      if (adjustableContent) {
        adjustableContent.style.overflowY = "";
        adjustableContent.style.height = "";
      }
    }
  };
  var startAnimation = function startAnimation() {
    calculateHeight();
    setFocusToFirstNode();
    scrollBehaviour("disable");
    data.onShow && data.onShow(elem);
    elem.removeEventListener("animationend", startAnimation, false);

    // dispatch modal show
    var event = new CustomEvent("apricot_modalShow");
    activeElement && activeElement.dispatchEvent(event);
    elem.dispatchEvent(event);
  };
  var endAnimation = function endAnimation() {
    Utils.removeClass(elem, "cb-open");
    elem.removeEventListener("animationend", endAnimation, false);

    // dispatch modal close
    var event = new CustomEvent("apricot_modalClose");
    activeElement && activeElement.dispatchEvent(event);
    elem.dispatchEvent(event);
  };

  // add/remove scroll option from body
  var scrollBehaviour = function scrollBehaviour(toggle) {
    if (!data.disableScroll) return;
    var body = document.querySelector("body");
    switch (toggle) {
      case "enable":
        body.style = _objectSpread(_objectSpread({}, body.style), {
          overflow: "",
          height: ""
        });
        break;
      case "disable":
        body.style = _objectSpread(_objectSpread({}, body.style), {
          overflow: "hidden",
          height: "100vh"
        });
        break;
      default:
    }
  };

  /**
   * Shows modal
   * @return {void}
   */
  var show = function show() {
    showModal();
  };

  /**
   * Closes modal
   * @param {Object} options
   * @param  {Function} options.onClose [callback function to call when modal closes]
   * @return {void}
   */
  var close = function close() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    closeModal(options);
    removeEventListeners();
    cleanUp();
  };

  /**
   * Adjust Height for active modal
   * @return {void}
   */
  var adjustHeight = function adjustHeight() {
    if (elem && Utils.hasClass(elem, "cb-open")) {
      calculateHeight();
    }
  };
  var destroy = function destroy() {
    if (elem.modal === "cb") {
      elem.modal = null;
      removeEventListeners();
      cleanUp();
      if (Utils.elemExists(trigger)) {
        trigger.removeEventListener("click", showModal);
      }
    }
  };
  if (elem.modal !== "cb") {
    init();
  } else {
    modalComponents();
  }
  return {
    show: show,
    close: close,
    adjustHeight: adjustHeight,
    destroy: destroy
  };
};
export default Modal;